module.exports = __webpack_public_path__ + "static/media/box-open.87f0e5f9.svg";